<template>
  <v-list class="breadcrumb-sub-list">
    <template v-for="(item, i) in value">
      <v-list-item v-if="item" :key="item.id" @click.capture.stop="$emit('click', item)">
        <v-list-item-icon>
          <v-icon v-if="item.icon" left color="primary">
            {{ item.icon }}
          </v-icon>
        </v-list-item-icon>
        <v-list-item-title>
          <span class="text-truncate truncated-title">{{ item.title }}</span>
        </v-list-item-title>
      </v-list-item>
      <v-divider v-if="!item" :key="'divider_' + i"></v-divider>
    </template>
  </v-list>
</template>
<script>
export default {
  name: 'BreadcrumbSubList',
  props: {
    value: {
      type: Array,
      description: 'Breadcrumb items for sub list'
    }
  }
}
</script>
<style lang="scss" scoped>
.truncated-title {
  max-width: 585px;
}
</style>
